export default "__VITE_ASSET__vIY7WPbi__"